import React from 'react';

const ProfilePage = () => {
    return (
        <div>

        </div>
    );
};

export default ProfilePage;